
import { Component, Vue } from 'vue-property-decorator';
import SearchBar from '~/components/SearchBar.vue';

@Component({
    components: {
        SearchBar,
    },
})
export default class SupportIndex extends Vue {
}
